import api from './apiService';
import apiRoutes from './apiRoutes';

// Read-only leader self-service (V2 §3.5b). Self-scoped via the token.

// The caller's active positions: { items: [{ employeePositionId, departmentId, positionId, positionTitle, departmentName }] }
export const getMyLeaderPositionsAsync = async () => {
  try {
    const response = await api.get(apiRoutes.leader.myPositions);
    return response.result.items || [];
  } catch (error) {
    throw error;
  }
};

// The caller's subordinates, grouped by the caller's position:
// { positions: [{ superiorEmployeePositionId, positionTitle, departmentName, subordinates: [...] }] }
export const getMySubordinatesAsync = async () => {
  try {
    const response = await api.get(apiRoutes.leader.mySubordinates);
    return response.result.positions || [];
  } catch (error) {
    throw error;
  }
};
